import { breakpoints } from '../constants/breakpoints.constants'

export const scrollToTop = () => setTimeout(() => window.scrollTo(0, 0))

export const isMobile = () => window.innerWidth < breakpoints.MOBILE
